<script>
import { ref } from 'vue'

export default {
  setup(props, { slots }) {
    const active  = ref('')
    const toggle  = (payload) => {
      console.log(payload)
      if ( active.value === payload ) {
        active.value = ''
      } else {
        active.value = payload
      }
    }

    return () => slots.default({
      active: active.value,
      toggle
    })
  }
}
</script>